import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  InfoAgentsAction, 
  setAgents,
  setAgentsContent, 
  setIsFetchingAgents, 
  setIsFetchingContent, 
  setFetchAgentsFailed, 
  setFetchContentFailed, 
} from 'Components/InfoAgents/Redux/actions';
import moment from 'moment';

export const fetchAgentsContent = () => {
  return async (dispatch: Dispatch<InfoAgentsAction>): Promise<void> => {
    const { isFetchingContent, content } = Store.getState().infoAgents;

    if (isFetchingContent || content) {
      return null;
    }

    dispatch(setIsFetchingContent());

    try {
      const response = await Api.get('AgentsPage');

      if (response.status !== 200) {
        dispatch(setFetchContentFailed());
      } else {
        const newContent: Julius.Website.AgentsPageViewModel = await response.json();
        dispatch(setAgentsContent(newContent));
      }
      
    } catch (e) {
      dispatch(setFetchContentFailed());
    }
  };
};

export const fetchAgents = () => {
  return async (dispatch: Dispatch<InfoAgentsAction>): Promise<void> => {
    const { isFetchingAgents, agents } = Store.getState().infoAgents;

    if (isFetchingAgents || agents) {
      return null;
    }

    dispatch(setIsFetchingAgents());

    try {
      const response = await Api.get('Agents');

      if (response.status !== 200) {
        dispatch(setFetchAgentsFailed());
      } else {
        const newAgents: Julius.Website.AgentViewModel[] = await response.json();

        newAgents.map(agent => {
          agent.openHoursList.map(hours => {
            hours.date = moment(hours.date).toDate();
            hours.open1 = moment(hours.open1).toDate();
            hours.open2 = moment(hours.open2).toDate();
            hours.close1 = moment(hours.close1).toDate();
            hours.close2 = moment(hours.close2).toDate();
          });
        });
        
        dispatch(setAgents(newAgents));
      }
      
    } catch (e) {
      dispatch(setFetchAgentsFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/InfoAgents/Redux/thunks.tsx